import fileModel from '@/shared/file/file-model';

export default {
  default() {
    return {
      id: null,
      picture: {
        name:"",
        size:0,
        url:""
      }
    }
  },

  forSimple(data){
    return  {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : ''
    }
  },

  forCreate(data) {
    return {
      ...data,
      picture: fileModel.toDatabaseFile(data.picture)
    };
  },

  forTeam(data) {
    return  { 
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : '',
      birthdate: data.birthdate ? data.birthdate: '',
      email: data.email ? data.email : '',
      picture: data.picture ? fileModel.toDatabaseFile(data.picture) : {
        name:"",
        size:0,
        url:""
      },
      dni: data.dni ? data.dni : '',
      phone: data.phone ? data.phone : ''
    }
  },
  
  forUpdate(data) {
    return {
      ...data,     
       picture: fileModel.toDatabaseFile(data.picture)
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/team-manager/team-manager-model.js